// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__ZqVLa","nav":"NavBar_nav__aE7kl","logo":"NavBar_logo__OGFVx","login":"NavBar_login__7xusG"};